// TODO: Refactor together with Review Insights

enum ReviewFilterNamesEnum {
  RATING = 'rating',
  REVIEW_TYPE = 'reviewType',
  REPLY = 'reply'
}

export enum SharedFilterNamesEnum {
  FROM_DATE = 'fromDate',
  TO_DATE = 'toDate',
  CITY = 'city',
  ADDRESS = 'address',
  COUNTRY_CODES = 'countryCodes',
  STORE_CODE = 'storeCode',
  BUSINESS_NAME = 'businessName',
  SORT_BY = 'sortBy'
}

export const ReviewFilterNames = {
  ...ReviewFilterNamesEnum,
  ...SharedFilterNamesEnum,
};
